import { render, staticRenderFns } from "./jobDetailPage.vue?vue&type=template&id=f8895778"
import script from "./jobDetailPage.vue?vue&type=script&lang=js"
export * from "./jobDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports